import axios from 'axios'

const Net = axios.create({
  baseURL: 'http://139.9.67.131:8080',
  timeout: 5000,
  validateStatus(status) {
    return status < 500; // 状态码在大于或等于500时才会 reject
  }
})

// 添加请求拦截器
Net.interceptors.request.use(function (config) {
  if (localStorage.Authorization) {
    config.headers.Authorization = localStorage.Authorization
  }
  console.log(config)
  return config;
}, function (error) {
  return Promise.reject(error);
})
// 添加响应拦截器
Net.interceptors.response.use(function (response) {
  console.log(response)
  // 尝试在此处判断ErrorCode
  const code = response.data.ErrorCode
  if (code) {
    if (code === 40300) {
      localStorage.setItem('Authorization', '')
      alert('请重新登录后再次尝试此操作。错误码40300')
    } else if (code === 40400) {
      localStorage.setItem('Authorization', '')
      alert('登录已过期，请重新登录')
    } else if (code === 40500) {
      alert('登陆后才能访问该内容！')
    } else if (code === 45009) {
      alert('密码错误，请重试')
    } else {
      alert(`错误码：${code}\n错误信息：${ClientErrorCode(code)}；请联系管理人员`)
    }
    return Promise.reject(response)
  }
  return response.data;
}, function (error) {
  if (error.toString().includes('timeout')) {
    alert('网络超时，请稍后再试。')
  }
  return Promise.reject(error)
})

const network = {
  async getVeriCode() {
    return await Net.get('/verificationcode')
  },
  async getArticle(id) {
    return (await Net.get(`/article/${id}`)).Data
  },
  index: {
    ///////首页
    async login(data) {
      return await Net.post('/console/login', data)
    },
    async getIndexData() {
      return await Net.get('/')
    },
    async search(word, type) {
      return (await Net.get(`/search/keyword=${word}&query_type=${type}`)).Data
    },
    async getDownloadAcademic() {
      return (await Net.get('/p/xzzx/xsjl')).Data
    },
    async getDownloadKnowledge() {
      return (await Net.get('/p/xzzx/yjcs')).Data
    },
    async getDownloadVideo() {
      return (await Net.get('/p/xzzx/zxsp')).Data
    },
    async getDownloadDetail(id) {
      return (await Net.get('/downloadresource/' + id)).Data
    },
    async postSuggest(data) {
      return await Net.post('/suggest', data)
    },
    async getLast(type) {
      return ((await Net.get(`/latest/${type}`)).Data) || []
    },
    async getLink(){
      return (await Net.get('/links')).Data;
    },
    async getMail(){
      return (await Net.get('/email')).Email
    },
    async getDldDetail(id){
      return (await Net.get(`/downloadresource/${id}`)).Data
    }
  },
  introduce: {
    ////// 中心概况
    async getIntroduce() {
      return (await Net.get('/p/zxgk/zxjj')).Data.Content
    },
    async getTeam() {
      return (await Net.get('/p/zxgk/yjtd'))
    },
    async getDetail(id) {
      return (await Net.get(`/expert/${id}`)).Data
    },
    async getItem() {
      return (await Net.get('/p/zxgk/yjxm')).Data
    },
    async getStructure() {
      return (await Net.get('/p/zxgk/zzjg')).Data
    },
    async getDirection() {
      return (await Net.get('/p/zxgk/kxyj/yjfx')).Data
    },
  },
  academic: {
    //////学术交流
    async getOpinions() {
      return (await Net.get('/p/xsjl/gdzy')).Data
    },
    async getOpinionContent(id) {
      return (await Net.get(`/summary_of_view/${id}`)).Data
    },
    async getTrends() {
      return (await Net.get('/p/xsjl/yjdt')).Data
    },
    async getTrendsDetail(id) {
      return (await Net.get(`/article/${id}`)).Data
    },
  },
  studyResult: {
    ////// 研究成果
    async getResearchReport() {
      return (await Net.get('/p/yjcg/yjbg')).Data
    },
    async getAcademicPaper() {
      return (await Net.get('/p/yjcg/xslw')).Data
    },
    async getPublication() {
      return (await Net.get('/p/yjcg/cbzz')).Data
    },
    async getAchievementApply() {
      return (await Net.get('/p/yjcg/cgyy')).Data
    },
    async getPaperDetail(id) {
      return (await Net.get('/academic_paper/' + id)).Data
    },
    async getResultDetail(id) {
      return (await Net.get(`/research_report/${id}`)).Data
    },
    async getApplyDetail(id) {
      return (await Net.get(`/article/${id}`)).Data
    }
  },

  emrClass: {
    /////////应急课堂
    async getVideo(type) {
      return (await Net.get(`/p/yjkt/zxwk/${type}`)).Data
    },
    async getVideoDetail(id) {
      return (await Net.get(`/course/${id}`)).Data
    },
    async getVideoUrl(id) {
      return (await Net.get(`/video_play/${id}`)).VideoUrl
    },
    async getKnowledge() {
      return (await Net.get('/p/yjkt/yjcs')).Data
    },
    async getKnowledgeDetail(id) {
      return (await Net.get(`/article/${id}`)).Data
    },
  },

  experts: {
    /////////应急管理专家库
    async getExperts() {
      return (await Net.get('/p/yjglzjk')).Data
    },
    async getDetail(id) {
      return (await Net.get(`/expert_internal/${id}`)).Data
    }
  },
  dataAndCases: {
    //////////// 案例库
    async getLaws() {
      return (await Net.get('/p/xxzlyalk/yjflfg')).Data
    },
    async getCases() {
      return (await Net.get('/p/xxzlyalk/yjglal')).Data
    },
    async getPapers() {
      return (await Net.get('/p/xxzlyalk/yjgllw')).Data
    },
    async getDetail(id) {
      return (await Net.get('/case/' + id)).Data
    },
    async getCollections() {
      return (await Net.get('/case/collection')).Data
    },
    async collect(id) {
      return (await Net.post('/case/collection', {
        Id: id
      })).ErrorCode
    },
    async cancelCollect(id) {
      return (await Net.delete('/case/collection/' + id)).ErrorCode
    },
  },
}

export default network

function ClientErrorCode(code) {
  switch (code) {
    case 40001:
      return '缺少必要的参数'
    case 40002:
      return '该资源不存在'
    case 40003:
      return '数据库相关出错'
    case 40004:
      return '文件接收出错'
    case 40005:
      return 'URL参数错误'
    case 40006:
      return '修改课程错误'
    case 40007:
      return '登录出错'
    case 40008:
      return '轮播图出错'
    case 40012:
      return '该导航栏不存在'
    case 41001:
      return '阿里云OSS服务连接 出错'
    case 41002:
      return '阿里云OSS服务文件 出错'
    case 41101:
      return '华为云视频上传出错'
    case 40300:
      return '非法token'
    case 40400:
      return '过期token'
    case 40500:
      return '无权操作'
    case 40510:
      return '无权下载'
    case 44000:
      return '上传数据格式问题'
    case 48000:
      return '验证码答案错误'
    case 49100:
      return '用户名或密码太短，长度必须大于等于5'
    case 49200:
      return '用户名已存在'
  }
}